<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="DashboardFullfilment"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-3 mb-md-0">Proforma Invoice : Created</h4>
            </div>
          </div>
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="search.pi_number"
                          type="text"
                          @keyup.enter="loadItems"
                          placeholder="PI Number"
                        />
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        <input
                          class="form-control"
                          v-model="search.load_id"
                          @keyup.enter="loadItems"
                          type="text"
                          placeholder="Load Id"
                        />
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        <v-select
                              @input="loadItems"
                              :options="['CREATE','POST','PRINT','REQUEST TO EDIT']"
                              v-model="search.status"
                              v-bind:style="{padding: 0}"
                              class="form-control"
                              placeholder="Status"
                              label="code"
                              
                            ></v-select>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="input-group">
                        
                      <multiselect
                          @search-change="asyncSearchCompany"
                          v-model="company"
                          :options="fetchCompany"
                          label="name"
                          :searchable="true"
                          track-by="name"
                          ref="inputCompany"
                          placeholder="Please Select Company"
                          :custom-label="company_label"
                          @input="loadItems"
                        >
                          <span slot="noResult">-</span>
                        </multiselect>
                      </div>
                    </div>
                    <div class="col-lg-auto col-md-12 col-sm-12 col-xs-12 mb-3">
                      <div class="row justify-content-start">
                        <div class="col-auto">
                          <button @click="loadItems" class="btn btn-primary">
                            {{$t('search_txt')}}
                          </button>
                        </div>
                        <div class="col-auto">
                          <button class="btn btn-primary" @click="resetFilter">
                            {{$t('resetFilter')}}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      class=" col-lg-auto col-md-12 col-sm-12 col-xs-12 mb-3"
                    >
                      <button
                        @click="createData()"
                        class="btn btn-warning float-end"
                      >
                        {{ $t("create_proforma_invoice") }}
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12">
                      <vue-good-table
                        title="list-order-ct"
                        mode="remote"
                        :select-options="{
                          enabled: true,
                          selectOnCheckboxOnly: true,
                          selectionText: $t('data_selected'),
                          clearSelectionText: $t('clear'),
                        }"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-selected-rows-change="selectionChanged"
                        :pagination-options="{
                          enabled: true,
                        }"
                        :rows="rows"
                        :columns="columns"
                      >
                        <div slot="selected-row-actions">
                          <button
                            class="btn btn-success btn-xs"
                            style="margin-right: 20px"
                            @click="downloadData"
                            v-show="isCreate"
                          >
                            <i class="mdi mdi-file-document"></i
                            >{{ $t("downloadData") }} .xlsx
                          </button>
                          <button
                            class="btn btn-warning btn-xs"
                            @click="confirmPi"
                            v-show="permision_role.method_upload && isCreate"
                          >
                            <i class="mdi mdi-send"></i>
                            {{$t('confirmPi')}}
                          </button>
                          <button
                            class="btn btn-primary btn-xs"
                            style="margin-right: 20px"
                            @click="downloadDataPdf"
                            v-show="permision_role.method_custom1 && (isPost || isPrint)"
                          >
                            <i class="mdi mdi-file-document"></i
                            >{{ $t("downloadData") }} PDF
                          </button>
                          <!-- <button
                            class="btn btn-warning btn-xs"
                            @click="confirmPiPost"
                            v-show="isPost"
                          >
                            {{ $t('confirmPi') }}
                          </button> -->
                          <button
                            class="btn btn-success btn-xs"
                            style="margin-right: 20px"
                            @click="downloadDataPrint"
                            v-show="permision_role.method_custom1 && isPrint"
                          >
                            <i class="mdi mdi-file-document"></i
                            >{{ $t("downloadData") }} .xlsx
                          </button>
                        </div>
                        <template slot="table-row" slot-scope="props">
                          <span v-if="props.column.field == 'actions'">
                            <button
                              type="button"
                              class="btn btn-warning btn-icon mx-1"
                              v-show="props.row.status == 'CREATE' && permision_role.method_update"
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Edit"
                              @click="editData(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-pencil"
                                style="font-size: 16px"
                              ></i>
                            </button>
                            <button
                              type="button"
                              class="btn btn-warning btn-icon mx-1"
                              v-show="props.row.status == 'POST' && permision_role.method_update"
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Edit"
                              @click="backNew(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-undo-variant"
                                style="font-size: 16px"
                              ></i>
                            </button>

                            <button
                              type="button"
                              class="btn btn-primary btn-icon  mx-1"
                              v-show="(props.row.status == 'PRINT' || props.row.status == 'CREATE') && permision_role.method_delete"
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Delete"
                              @click="deleteData(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-delete"
                                style="font-size: 16px"
                              ></i>
                            </button>
                             <button
                              type="button"
                              class="btn btn-warning btn-icon  mx-1" 
                              style="
                                color: white;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="History"
                              @click="historyData(props.index, props.row)"
                            >
                              <i
                                class="mdi mdi-history"
                                style="font-size: 16px"
                              ></i>
                            </button>
                          </span>
                          <span v-else-if="props.column.field == 'entries'">
                            <a
                              style="
                                color: #ab0635;
                                text-decoration: none;
                                cursor: pointer;
                              "
                              title="Detail Load Id"
                              @click.prevent="detailPi(props.row)"
                            >
                              {{ props.row.entries }}
                            </a>
                          </span>
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>
                      </vue-good-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <modal-proformaInvoiceDetail
            :showModal="showModalPI"
            :data="this.detailData"
            @closeModal="closeMyModal"
          >
          </modal-proformaInvoiceDetail>

          <modal-proformaInvoiceHistory
            :showModal="showModalHistoryPI"
            :data="this.detailData"
            @closeModal="closeMyModal"
          >
          </modal-proformaInvoiceHistory>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import ModalProformaInvoiceDetail from "@/components/modal/modalProformaInvoiceDetail.vue";
import ModalProformaInvoiceHistory from "@/components/modal/modalProformaInvoiceHistory.vue";
import multiselect from "vue-multiselect";

export default {
  name: "proformaInvoiceCreated",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    "modal-proformaInvoiceDetail": ModalProformaInvoiceDetail,
    "modal-proformaInvoiceHistory": ModalProformaInvoiceHistory,
    multiselect,
  },
  data() {
    return {
      closeBtn: true,
      permision_role: [],
      isLoading: false,
      errors: [],
      proformaInvoiceNo: "",
      loadId: "",
      totalRecords: 0,
      showModalPI: false,
      rowsSelection: [],
      detailData: [],
      search: {
        pi_number: "",
        load_id: "",
        status: "",
      },
      columns: [
        {
          label: this.$t("piNumber"),
          field: "pi_number",
        },
        {
          label: this.$t("companyName"),
          field: "company_name",
        },
        {
          label: "Entries",
          field: "entries",
        },
        {
          label: "Total",
          field: "total",
          formatFn: this.formatCurrency,
        },
        {
          label: "Status",
          field: "status",
          sortable: false,
        },
        {
          label: this.$t("create_at_txt"),
          field: "created_at",
          type: "date",
          tdClass: 'text-left',
          dateInputFormat: "yyyy-MM-dd HH:mm:ss",
          dateOutputFormat: "dd MMM yyyy h:mm:ss a", //'dd MMM yyyy',
        },
        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        },
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      rows: [],
      isCreate:false,
      isPost:false,
      isPrint:false,
      showModalHistoryPI:false,
      fetchCompany: [],
      company:null,
    };
  },
  methods: {
    company_label(ev){
      return ev.code + " | "+ ev.name ;
    },
    asyncSearchCompany(ev) {
      const baseURI = this.$settings.endPoint + "company/select?status=active&limit=10&name=" + ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI = this.$settings.endPoint + "company/select?status=active&limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },
    confirmPi() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then(async (result) => {
        if (result.value) {
          let res = [];
          this.fade(true);
          await Promise.all(this.rowsSelection.map(async (item)=>{
                 const baseURI =
                this.$settings.endPointProformaInvoice +
                "v1/proforma-invoice/post/" +
                item.proforma_invoice_header_id;

              let reqRes = await this.$http
                .post(baseURI)
                .then((response) => {
                  if (response.data.status === 200) {
                    return true;
                  } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    return false;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 500) {
                      this.$router.push("/server-error");
                    } else {
                      this.$router.push("/page-not-found");
                    }
                  }
                  return false;
                });

              if (reqRes) {
                res.push("<p style='color:green'>"+item.pi_number + " Success </p>");
              } else {
                res.push("<p style='color:red'>"+item.pi_number + " Failed </p>");
              }
          }))
          // this.rowsSelection.forEach(async (item) => {
          //   const baseURI =
          //     this.$settings.endPointProformaInvoice +
          //     "v1/proforma-invoice/post/" +
          //     item.proforma_invoice_header_id;

          //   let reqRes = await this.$http
          //     .post(baseURI)
          //     .then((response) => {
          //       if (response.data.status === 200) {
          //         return true;
          //       } else {
          //         this.errors = response.data.errors;
          //         this.resultError(response.data.errors);
          //         return false;
          //       }
          //     })
          //     .catch((error) => {
          //       if (error.response) {
          //         if (error.response.status === 422) {
          //           this.errors = error.response.data.errors;
          //           this.resultError(error.response.data.errors);
          //         } else if (error.response.status === 500) {
          //           this.$router.push("/server-error");
          //         } else {
          //           this.$router.push("/page-not-found");
          //         }
          //       }
          //       return false;
          //     });

          //   if (reqRes) {
          //     res.push(item.pi_number + " Success <br>");
          //   } else {
          //     res.push(item.pi_number + " Failed <br>");
          //   }

          // });

          this.$swal({
            icon:'info',
            title:"Info",
            html:res
          });
          this.loadItems();
        }
      });
    },
    downloadData() {
      this.$swal({
        icon: "warning",
        title: "Please Wait",
        text: "Don't Close This Page !!!",
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        didOpen: async () => {
          this.$swal.showLoading();
          let res = [];
          await Promise.all(this.rowsSelection.map(async (item)=>{
            const baseURI =
              this.$settings.endPointProformaInvoice +
              "v1/proforma-invoice/download-excel/" +
              item.proforma_invoice_header_id;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name =
              "proforma_invoice_" +
              item.pi_number +
              "_" +
              CurrentDate +
              ".xlsx";
            
            let reqRes = await this.$http
              .get(baseURI, { responseType: "blob" })
              .then((response) => {
                var fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                console.log(response.data);
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                return true;
              })
              .catch((error) => {
                console.log(error.response);
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
                return false;
              });

            if (reqRes) {
              res.push(item.pi_number + " Success <br>");
            } else {
              res.push(item.pi_number + " Failed <br>");
            }
          }));

          this.$swal.close();
            this.$swal({
              icon:'info',
              title:"Info",
              html:res
            });
            this.loadItems();
        },
        // async onOpen(){
        //   const baseURI = this.$settings.endPointProformaInvoice + "v1/proforma-invoice/recalculate/" + this.forms.proforma_invoice_header_id;
        //   await this.$http.post(baseURI).then(() => {
        //     this.loadItems();
        //     this.$swal.close();
        //   });
        // },
      }).then(() => {
        this.loadItems();
      });
    },
    closeMyModal() {
      this.showModalPI = false;
      this.showModalHistoryPI = false;
      this.loadItems();
    },
    detailPi(row) {
      this.detailData["method"] = "detail";
      this.detailData["data"] = row;
      this.showModalPI = true;
    },
    historyData(index,row) {
      this.detailData["data"] = row;
      this.showModalHistoryPI = true;
    },
    resetFilter() {
      this.search.pi_number = "";
      this.search.load_id = "";
      this.search.status = "";
      this.serverParams.page = 1;
      this.serverParams.per_page = 10;
      this.company = null;
      this.loadItems();
    },
    formatCurrency(val) {
      return parseInt(val).toLocaleString();
    },
    
    deleteData(index, data) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          const baseURI =
            this.$settings.endPointProformaInvoice +
            "v1/proforma-invoice/delete/" +
            data.proforma_invoice_header_id;

          this.$http
            .delete(baseURI)
            .then((response) => {
              if (response.data.status === 200) {
                this.success("Success");
                this.loadItems();
                return true;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                return false;
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              return false;
            });

        }
      });
    },
    backNew(index, data) {
      // console.log(data, index);
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then(async (result) => {
        if (result.value) {
          this.fade(true);
          const baseURI =
            this.$settings.endPointProformaInvoice +
            "v1/proforma-invoice/return/" +
            data.proforma_invoice_header_id;

          await this.$http
            .post(baseURI)
            .then((response) => {
              if (response.data.status === 200) {
                return true;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                return false;
              }
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              return false;
            });
          this.loadItems();
        }
      });
    },
    editData(index, data) {
      var params = this.$onRandom(data.proforma_invoice_header_id);
      this.$router.push('/proforma-invoice/add/'+params);
      // window.location.href = "/proforma-invoice/add/" + params;
    },
    createData() {
      this.fade(true);

      this.$router.push('/proforma-invoice/add');
      // const baseURI =
      //   this.$settings.endPointProformaInvoice + "v1/proforma-invoice/create";

      // return this.$http
      //   .post(baseURI)
      //   .then((response) => {
      //     var params = this.$onRandom(
      //       response.data.datas.proforma_invoice_header_id
      //     );
      //     window.location.href = "/proforma-invoice/add/" + params;

      //     this.loading();
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    fade(type) {
      this.isLoading = type;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
    loadItems() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/proforma-invoice/index";
      let status = "create,post,print";
      if(this.search.status){
        status = this.search.status;
      }
      let company = this.company?.company_id ? this.company.company_id : '';
      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&pi_number=${this.search.pi_number}&load_id=${this.search.load_id}&status=${status}&company_id=${company}`
        )
        .then((response) => {
          this.rows = [];
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.loading();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    selectionChanged(ev) {
      this.rowsSelection = [];
      this.rowsSelection = ev.selectedRows;
      let status = []; 
      this.rowsSelection.forEach((item)=>{
        status.push(item.status);
      })

      let unique = [...new Set(status)];

      if(unique.length == 1){
        let selectedStatus = unique[0];

        if(selectedStatus == "PRINT"){
          this.isPrint = true;
        }
        if(selectedStatus == "POST"){
          this.isPost = true;
        }
        if(selectedStatus == "CREATE"){
          this.isCreate = true;
        }
      }else{
        
        this.isCreate = false
        this.isPost   = false
        this.isPrint  = false
      }
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ProformaInvoiceController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
     
    downloadDataPdf() {
      this.$swal({
        icon: "warning",
        title: "Please Wait",
        text: "Don't Close This Page !!!",
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        didOpen: async () => {
          this.$swal.showLoading();
          let res = [];
          await Promise.all(this.rowsSelection.map(async (item)=>{
            const baseURI =
              this.$settings.endPointProformaInvoice +
              "v1/proforma-invoice/download-pdf/" +
              item.proforma_invoice_header_id;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name =
              "proforma_invoice_" +
              item.pi_number +
              "_" +
              CurrentDate +
              ".pdf";
            
            let reqRes = await this.$http
              .get(baseURI, { responseType: "blob" })
              .then((response) => {
                var fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                console.log(response.data);
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                return true;
              })
              .catch((error) => {
                console.log(error.response);
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
                return false;
              });

            if (reqRes) {
              res.push(item.pi_number + " Success <br>");
            } else {
              res.push(item.pi_number + " Failed <br>");
            }
          }));

          this.$swal.close();
          this.$swal({
            icon:'info',
            title:"Info",
            html:res
          });
          this.loadItems();
        },
        // async onOpen(){
        //   const baseURI = this.$settings.endPointProformaInvoice + "v1/proforma-invoice/recalculate/" + this.forms.proforma_invoice_header_id;
        //   await this.$http.post(baseURI).then(() => {
        //     this.loadItems();
        //     this.$swal.close();
        //   });
        // },
      }).then(() => {
        this.loadItems();
      });
    },
    confirmPiPost() {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then(async (result) => {
        if (result.value) {
          let res = [];
          this.fade(true);
          await Promise.all(
            this.rowsSelection.map(async (item) => {
              const baseURI =
                this.$settings.endPointProformaInvoice +
                "v1/proforma-invoice/print/" +
                item.proforma_invoice_header_id;

              let reqRes = await this.$http
                .post(baseURI)
                .then((response) => {
                  if (response.data.status === 200) {
                    return true;
                  } else {
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                    return false;
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 500) {
                      this.$router.push("/server-error");
                    } else {
                      this.$router.push("/page-not-found");
                    }
                  }
                  return false;
                });

              if (reqRes) {
                res.push(
                  "<p style='color:green'>" + item.pi_number + " Success </p>"
                );
              } else {
                res.push(
                  "<p style='color:red'>" + item.pi_number + " Failed </p>"
                );
              }
            })
          );

          this.$swal({
            icon: "info",
            title: "Info",
            html: res,
          });
          this.loadItems();
        }
      });
    },
    downloadDataPrint(){
      this.$swal({
        icon: "warning",
        title: "Please Wait",
        text: "Don't Close This Page !!!",
        timerProgressBar: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false, // There won't be any cancel button
        showConfirmButton: false, // There won't be any confirm button
        didOpen: async () => {
          this.$swal.showLoading();
          let res = [];
          await Promise.all(this.rowsSelection.map(async (item)=>{
            const baseURI =
              this.$settings.endPointProformaInvoice +
              "v1/proforma-invoice/download-excel/" +
              item.proforma_invoice_header_id;
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name =
              "proforma_invoice_" +
              item.pi_number +
              "_" +
              CurrentDate +
              ".xlsx";
            
            let reqRes = await this.$http
              .get(baseURI, { responseType: "blob" })
              .then((response) => {
                var fileURL = window.URL.createObjectURL(
                  new Blob([response.data])
                );
                var fileLink = document.createElement("a");
                console.log(response.data);
                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                return true;
              })
              .catch((error) => {
                console.log(error.response);
                if (error.response) {
                  if (error.response.status === 422) {
                    this.errors = error.response.data.errors;
                  } else if (error.response.status === 500) {
                    this.$router.push("/server-error");
                  } else {
                    this.$router.push("/page-not-found");
                  }
                }
                return false;
              });

            if (reqRes) {
              res.push(item.pi_number + " Success <br>");
            } else {
              res.push(item.pi_number + " Failed <br>");
            }
          }));

          this.$swal.close();
            this.$swal({
              icon:'info',
              title:"Info",
              html:res
            });
            this.loadItems();
        },
      }).then(() => {
        this.loadItems();
      });
    },
    // downloadDataPrint(){
    //   this.$swal({
    //     icon: "warning",
    //     title: "Please Wait",
    //     text: "Don't Close This Page !!!",
    //     timerProgressBar: true,
    //     allowOutsideClick: false,
    //     allowEscapeKey: false,
    //     allowEnterKey: false,
    //     showCancelButton: false, // There won't be any cancel button
    //     showConfirmButton: false, // There won't be any confirm button
    //     didOpen: async () => {
    //       this.$swal.showLoading();

    //       let list = "";
    //       this.rowsSelection.forEach((item)=>{
    //         if(list == ''){
    //           list = list + item.proforma_invoice_header_id;
    //         }else{
    //           list = list + ","+item.proforma_invoice_header_id
    //         }            
    //       });
    //       const baseURI =
    //           this.$settings.endPointProformaInvoice +
    //           "v1/proforma-invoice/download-excel-print?proforma_invoice_header_id="+list;
    //         var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
    //         var file_name =
    //           "proforma_invoice_" +
    //           CurrentDate +
    //           ".xlsx";
            
    //         await this.$http
    //           .get(baseURI, { responseType: "blob" })
    //           .then((response) => {
    //             var fileURL = window.URL.createObjectURL(
    //               new Blob([response.data])
    //             );
    //             var fileLink = document.createElement("a");
    //             console.log(response.data);
    //             fileLink.href = fileURL;
    //             fileLink.setAttribute("download", file_name);
    //             document.body.appendChild(fileLink);
    //             fileLink.click();
    //             return true;
    //           })
    //           .catch((error) => {
    //             console.log(error.response);
    //             if (error.response) {
    //               if (error.response.status === 422) {
    //                 this.errors = error.response.data.errors;
    //               } else if (error.response.status === 500) {
    //                 this.$router.push("/server-error");
    //               } else {
    //                 this.$router.push("/page-not-found");
    //               }
    //             }
    //             return false;
    //           });
    //         this.$swal.close();

    //     },
    //   }).then(() => {
    //     this.$refs['vgtTable']. unselectAllInternal();
    //   });
    // },
  },
  mounted() {
    this.fetchIt();
    this.loadItems();
    this.loadCompany();
  },
};
</script>

<style>
.vgt-selection-info-row__actions.vgt-pull-right {
  float: right !important;
  margin-left: 10px;
}
</style>
